var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"checkbox_label",attrs:{"for":`checkbox${_vm.index}`}},[_c('a',{staticClass:"active",attrs:{"href":_vm.builtQueryString,"title":_vm.tag.tagAllSlug}},[_c('span',[_vm._v(_vm._s(_vm.tag.tagName))]),_vm._v(" "),_c('i',{staticClass:"lni lni-close"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }